import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import { ActionButton } from '../../../components/buttons/buttons';

class CustomDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      title: '',
      content: '',
      actions: [],
      onClose: () => {},
    };
  }

  showModal(metadata = {}) {
    this.modalHandler({
      show: true,
      ...metadata,
    })();
  }

  closeModal() {
    this.showModal({ show: false });
  }

  modalHandler(metadata = {}) {
    const { show = false, title = '', content = '', onClose = false, actions } = metadata;

    return () => {
      let { onClose: oldClose } = this.state;
      this.setState(
        {
          show,
          title,
          content,
          onClose: !show ? false : onClose,
          actions: !show ? [] : actions,
        },
        () => oldClose && !show && oldClose()
      );
    };
  }

  render() {
    const { show, title, content, actions: nactions } = this.state;

    const actions = !isEmpty(nactions)
      ? nactions
      : [
          <div className="padding-20px text-center">
            <ActionButton onClick={this.modalHandler({ show: false })}>OK</ActionButton>
          </div>,
        ];

    return (
      <MuiThemeProvider>
        <Dialog
          title={<div className="title-medium font-weight-800 text-center">{title}</div>}
          actions={actions}
          modal={true}
          open={show}
          onRequestClose={this.modalHandler({ show: false })}
          {...this.props}>
          <div className="title-small text-center padding-left-20px padding-right-20px">
            {content}
          </div>
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

export default CustomDialog;
